export const environment = {
  production: true,
  actionUrl: "http://api-pecplus.taxihandgo.com/app.php/api/"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts